import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useNavigate } from 'react-router-dom';

import { ConfirmDialog, UiModal } from 'shared/ui';
import {
  isErrorWithMessage,
  openErrorNotification,
  openSuccessNotification,
} from 'shared/lib';
import { ROLE_ROUTES } from 'shared/consts/routes/role';

import { useDeleteRoleMutation } from 'entities/role';

import { DELETE_ERROR, DELETE_SUCCESS } from '../consts';

type Props = {
  roleName: string;
};

export const DeleteRoleModal = NiceModal.create((props: Props) => {
  const modal = useModal();

  const [trigger, { isLoading }] = useDeleteRoleMutation();

  const navigate = useNavigate();

  const { roleName } = props;

  const handleDelete = async () => {
    try {
      const res = await trigger(roleName).unwrap();

      if (res.statusCode !== 0) {
        openErrorNotification(res.statusDescription);
        return;
      }

      openSuccessNotification(DELETE_SUCCESS);

      navigate(ROLE_ROUTES.ROLES);
    } catch (err) {
      const hasErrorMessage = isErrorWithMessage(err);

      const errorText = hasErrorMessage
        ? err.data.statusDescription
        : DELETE_ERROR;

      openErrorNotification(errorText);
    } finally {
      modal.hide();
    }
  };

  return (
    <UiModal
      title={`Удалить роль "${roleName}"?`}
      visible={modal.visible}
      onCancel={modal.hide}
      afterClose={modal.remove}
    >
      <ConfirmDialog
        onCancel={modal.hide}
        onConfirm={() => handleDelete()}
        loading={isLoading}
      />
    </UiModal>
  );
});
